/* eslint-disable react/destructuring-assignment */
import React from 'react'
import { useHistory } from 'react-router-dom'

import { makeStyles } from '@material-ui/core/styles'
import { DatePicker } from '@material-ui/pickers'
import Refresh from '@material-ui/icons/Refresh'

import Button from 'src/components/sharedComponents/CustomButtons/Button'
import CardTitle from 'src/components/sharedComponents/CardTitle'
import Total4WMarketProductsCard from 'src/components/reports/reportsBoard/4wCards/Total4WMarketProductsCard'

const useStyles = makeStyles(() => ({
  root: {
    '& > *': {
      color: '#fff',
    },
  },
}))


const Total4WMarketProductsPage = props => {
  const { selectedDate, handleDateChange } = props
  const classes = useStyles()
  const history = useHistory()

  return (
    <>
      <CardTitle
        title="Total mercado 4W por producto"
        component={
          <DatePicker
            autoOk
            variant="inline"
            views={['year']}
            className={classes.root}
            value={selectedDate}
            maxDate={new Date()}
            onChange={handleDateChange}
          />
        }
      />
      <Button link onClick={() => history.push('/reports/board')}>
        <Refresh /> Volver al Menú
      </Button>
      <Total4WMarketProductsCard
        cardTitle="Evolución total segmento - Personal / Cuadriciclos"
        selectedDate={selectedDate}
        arrayTable1={props.total7PC}
        arrayG1={props.gTotal8PC}
        paramG1="PERIODO1"
        arrayTable2={props.total9PC}
        paramT3="EMPRESA"
        arrayG3A={props.gTotal7APC}
        arrayG3B={props.gTotal7BPC}
        paramG3="EMPRESA"
      />
      <Total4WMarketProductsCard
        cardTitle="Evolución total mercado Pick Up"
        selectedDate={selectedDate}
        arrayTable1={props.total1MPK}
        arrayG1={props.gTotal2MPK}
        paramG1="PERIODO1"
        arrayTable2={props.total9MPK}
        paramT3="EMPRESA"
        arrayG3A={props.gTotal7AMPK}
        arrayG3B={props.gTotal7BMPK}
        paramG3="EMPRESA"
      />
      <Total4WMarketProductsCard
        cardTitle="Evolución total segmento - Personal / Pick Up"
        selectedDate={selectedDate}
        arrayTable1={props.total7PK}
        arrayG1={props.gTotal8PK}
        paramG1="PERIODO1"
        arrayTable2={props.total9PK}
        paramT3="EMPRESA"
        arrayG3A={props.gTotal7APK}
        arrayG3B={props.gTotal7BPK}
        paramG3="EMPRESA"
      />
      <Total4WMarketProductsCard
        cardTitle="Evolución total Comercial VAN"
        selectedDate={selectedDate}
        arrayTable1={props.total1VAN}
        arrayG1={props.gTotal2VAN}
        paramG1="PERIODO1"
        arrayTable2={props.total9VAN}
        paramT3="EMPRESA"
        arrayG3A={props.gTotal7AVAN}
        arrayG3B={props.gTotal7BVAN}
        paramG3="EMPRESA"
      />
      <Total4WMarketProductsCard
        cardTitle="Evolución total Comercial / Carga / VAN"
        selectedDate={selectedDate}
        arrayTable1={props.total7SVAN}
        arrayG1={props.gTotal2SVAN}
        paramG1="PERIODO1"
        arrayTable2={props.total9SVAN}
        paramT3="EMPRESA"
        arrayG3A={props.gTotal7ASVAN}
        arrayG3B={props.gTotal7BSVAN}
        paramG3="EMPRESA"
      />
      <Total4WMarketProductsCard
        cardTitle="Evolución total Comercial / Carga / ULTRA LIVIANOS"
        selectedDate={selectedDate}
        arrayTable1={props.total7ULIV}
        arrayG1={props.gTotal8ULIV}
        paramG1="PERIODO1"
        arrayTable2={props.total9ULIV}
        paramT3="EMPRESA"
        arrayG3A={props.gTotal7AULIV}
        arrayG3B={props.gTotal7BULIV}
        paramG3="EMPRESA"
      />
      <Total4WMarketProductsCard
        cardTitle="Evolución total Comercial / Carga / LIVIANOS"
        selectedDate={selectedDate}
        arrayTable1={props.total7LIV}
        arrayG1={props.gTotal8LIV}
        paramG1="PERIODO1"
        arrayTable2={props.total9LIV}
        paramT3="EMPRESA"
        arrayG3A={props.gTotal7ALIV}
        arrayG3B={props.gTotal7BLIV}
        paramG3="EMPRESA"
      />
      <Total4WMarketProductsCard
        cardTitle="Evolución total Comercial / Carga / PESADOS"
        selectedDate={selectedDate}
        arrayTable1={props.total7HEV}
        arrayG1={props.gTotal8HEV}
        paramG1="PERIODO1"
        arrayTable2={props.total9HEV}
        paramT3="EMPRESA"
        arrayG3A={props.gTotal7AHEV}
        arrayG3B={props.gTotal7BHEV}
        paramG3="EMPRESA"
      />
      <Total4WMarketProductsCard
        cardTitle="Evolución total Personal / PASAJEROS / TAXIS AUTOMÓVILES"
        selectedDate={selectedDate}
        arrayTable1={props.total7TAX}
        arrayG1={props.gTotal8TAX}
        paramG1="PERIODO1"
        arrayTable2={props.total9TAX}
        paramT3="EMPRESA"
        arrayG3A={props.gTotal7ATAX}
        arrayG3B={props.gTotal7BTAX}
        paramG3="EMPRESA"
      />
      <Total4WMarketProductsCard
        cardTitle="Evolución total Personal / PASAJEROS / TAXIS SUV"
        selectedDate={selectedDate}
        arrayTable1={props.total7TAXSUV}
        arrayG1={props.gTotal8TAXSUV}
        paramG1="PERIODO1"
        arrayTable2={props.total9TAXSUV}
        paramT3="EMPRESA"
        arrayG3A={props.gTotal7ATAXSUV}
        arrayG3B={props.gTotal7BTAXSUV}
        paramG3="EMPRESA"
      />
      <Total4WMarketProductsCard
        cardTitle="Evolución total Personal / PASAJEROS / MICRO BUS"
        selectedDate={selectedDate}
        arrayTable1={props.total7MICBUS}
        arrayG1={props.gTotal8MICBUS}
        paramG1="PERIODO1"
        arrayTable2={props.total9MICBUS}
        paramT3="EMPRESA"
        arrayG3A={props.gTotal7AMICBUS}
        arrayG3B={props.gTotal7BMICBUS}
        paramG3="EMPRESA"
      />
      <Total4WMarketProductsCard
        cardTitle="Evolución total Personal / PASAJEROS /  BUS"
        selectedDate={selectedDate}
        arrayTable1={props.total7BUS}
        arrayG1={props.gTotal8BUS}
        paramG1="PERIODO1"
        arrayTable2={props.total9BUS}
        paramT3="EMPRESA"
        arrayG3A={props.gTotal7ABUS}
        arrayG3B={props.gTotal7BBUS}
        paramG3="EMPRESA"
      />
      <Total4WMarketProductsCard
        cardTitle="Evolución total Personal / PASAJEROS /  BUSETA"
        selectedDate={selectedDate}
        arrayTable1={props.total7BUSETA}
        arrayG1={props.gTotal8BUSETA}
        paramG1="PERIODO1"
        arrayTable2={props.total9BUSETA}
        paramT3="EMPRESA"
        arrayG3A={props.gTotal7ABUSETA}
        arrayG3B={props.gTotal7BBUSETA}
        paramG3="EMPRESA"
      />
    </>
  )
}

export default Total4WMarketProductsPage
